import React, { useEffect, useState, useCallback } from 'react';
import {
  Button,
  ThemeProvider, Box, Card,
  Grid, createMuiTheme, CardHeader, CardContent, makeStyles,
  Avatar,
  GridList
} from '@material-ui/core';
import { Helmet } from 'react-helmet';


import './index.scss';
import { METADATA } from '../../constants';

/**Connections */
import Navbar from '../../components/Navbar';
import PresentationsTable from '../../components/Presentations/Table';

export default function Presentations() {

  return (
    <>
      <Helmet>
        <meta name="description" content={METADATA.PRESENTATIONS.description} />
        <title>{METADATA.PRESENTATIONS.title}</title>
      </Helmet>
      <Navbar />
      <Grid container className="dashboard-content container" justify="center">
        <Grid
          className="dashboard-content main-menu"
          justify="center"
          xs={12}
          md={12}
          lg={12}>
            <PresentationsTable></PresentationsTable>
        </Grid>
      </Grid>
    </>
  )
}